import React from 'react';
import './PaidPlanSelector.css';

interface PaidPlanSelectorProps {
  currentPlan: number;
}

const PaidPlanSelector: React.FC<PaidPlanSelectorProps> = ({ currentPlan }) => {
  const planOptions = [
    { value: 0, label: '일반 사용자', description: '기본 시험 기능' },
    { value: 1, label: 'Light User', description: '추가 연습 문제' },
    { value: 2, label: 'AI Power User', description: 'AI 기반 개인화 학습' }
  ];

  const currentPlanInfo = planOptions.find(plan => plan.value === currentPlan) || planOptions[0];

  return (
    <div className="paid-plan-selector">
      <h3>사용자 플랜</h3>
      <div className="current-plan">
        <div className="plan-badge">{currentPlanInfo.label}</div>
        <div className="plan-description">{currentPlanInfo.description}</div>
      </div>
    </div>
  );
};

export default PaidPlanSelector;